export const URL_INITIAL_PARAMS = {
  token: "widdetoken",
  email: "email",
  name: "name",
  hasAwaitScreen: "hasAwaitScreen",
  isGringa: "isGringa",
  isPolishop: "isPolishop",
  isCountdown: "isCountdown",
};
